import React from 'react';
import './BattenburgAnimation.css';

const BattenburgLoader = ({ width = 160, left = '50%', top = 160 }) => (
  <div
    className="tw-fixed tw-z-[2000]"
    style={{
      top: `${top}px`,
      left: typeof left === 'number' ? `${left}px` : left,
      transform: left === '50%' ? 'translateX(-50%)' : 'none',
    }}
  >
    <div
      className="tw-relative tw-h-6 tw-overflow-hidden tw-bg-transparent"
      style={{ width: `${width}px` }}
    >
      <div className="tw-absolute tw-top-0 tw-left-0 tw-flex tw-battenburg-scroll">
        {Array.from({ length: 40 }).map((_, i) => (
          <div
            key={i}
            className={`tw-w-6 tw-h-6 ${i % 2 === 0
                ? 'tw-bg-lime-400 tw-shadow-[0_0_6px_#84cc16]'
                : 'tw-bg-yellow-300 tw-shadow-[0_0_6px_#fde047]'
              }`}
          />
        ))}
      </div>
    </div>
  </div>
);

export default BattenburgLoader;